import React, { useEffect } from 'react'
import { useConcursoTikTok } from '../../../../hooks/useConcursoTikTok2025';
import { pathImages } from '../../../../routes/endpoints';

const Videos = () => {

    const { videos, getVideos,isWinnerTitlesPainted,setIsWinnerTitlesPainted,isSpecialMentionTitlesPainted,setIsSpecialMentionTitlesPainted} = useConcursoTikTok();
    let styleMenciones = isSpecialMentionTitlesPainted ?  '850px' :''
    useEffect(() => {
        getVideos(2026)
    }, [])

if (videos===undefined) {
    return(<>ddd</>);
}else{
  return (
      <div className="container-fluid section-home" id="videos">
          <div className="row justify-content-center">
              <div className="col-md-8 inner-sections">
                  <div className="title-tiktok-info">
                      <h2>Promocionales</h2>
                  </div>
                  <div className="container-inner-info p-4"> 
                         { isWinnerTitlesPainted ?  <div className='col-md-12 my-4'><h3 className="titulosVideosTikTok">Ganadoras y ganadores</h3></div> :<></>}
                        
                    <div className="row" style={{height:"850px"}}>                
                        {
                            videos?.map((item,key) =>  {
                                let {contenido,titulo,texto,tipo,icono} = item
                                if(tipo != 1 && !isWinnerTitlesPainted)
                                    setIsWinnerTitlesPainted(true);
                                let imagen = icono ? <img className="imgEncabezadoGanadores" src={`${pathImages}/${icono}`} alt="medallas" /> : <></>
                                let fragment = tipo == 1
                                ? <div className="inner-awards col-md-4">   
                                    <div className="iframe_container">                                    
                                        <div className='col-12'>
                                            <iframe 
                                                src={`https://www.tiktok.com/embed/${contenido}`}
                                                className="iframe"
                                                allow="encrypted-media" >
                                            </iframe> 
                                        </div>  
                                    </div>
                                    <div className="justify-content-center d-flex">
                                        <div className="h3 encabezadosGanadores vertical-align row">
                                            {titulo} {imagen}
                                        </div>
                                    </div>
                                    <div>{texto}</div>    
                                </div>   
                                :<></> 
                                return fragment;
                            })          
                        }
                    </div>
                        { isSpecialMentionTitlesPainted ?  <div className='col-md-12 my-4 mt-4'><br/><h3 className="titulosVideosTikTok mt-5">Menciones especiales</h3></div> :<></>}
                        <div className="row justify-content-center" style={{'height':styleMenciones}}>
                            {
                                videos?.map((item,key) =>  {
                                    let {contenido,titulo,texto,tipo,icono} = item
                                    if(tipo != 1 && !isSpecialMentionTitlesPainted)
                                        setIsSpecialMentionTitlesPainted(true);
                                    let imagen = icono ? <img className="imgEncabezadoGanadores" src={`${pathImages}/${icono}`} alt="medallas" /> : <></>
                                    let fragment = tipo != 1
                                    ? 
                                    <div className="inner-awards col-md-4 mt-4">   
                                        <div className="iframe_container">                                    
                                            <div className='col-12'>
                                                <iframe 
                                                    src={`https://www.tiktok.com/embed/${contenido}`}
                                                    className="iframe"
                                                    allow="encrypted-media" >
                                                </iframe> 
                                            </div>  
                                        </div>
                                        <div className="justify-content-center d-flex">
                                            <div className="h3 encabezadosGanadores vertical-align row">
                                                {titulo} {imagen}
                                            </div>
                                        </div>
                                        <div>{texto}</div>    
                                    </div>   
                                    :<></> 
                                    return fragment;
                                })          
                            }
                        </div>
                  </div>
              </div>
          </div>
      </div>
  )
}
}

export default Videos
